export default __webpack_public_path__ + "c20a54a073caf8ab2ca622e3072f4f36.png";